import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Pagination } from '../../models/pagination.model';
import * as paginationActions from '../actions/pagination.actions';

export interface PaginationState extends EntityState<Pagination> {}

export const paginationAdapter: EntityAdapter<Pagination> =
  createEntityAdapter<Pagination>();

export const initialState: PaginationState = paginationAdapter.getInitialState(
  {}
);

export const paginationReducer = createReducer(
  initialState,
  on(paginationActions.addToStore, (state, { pagination }) => {
    return paginationAdapter.upsertOne(pagination, {
      ...state,
    });
  }),
  on(paginationActions.updateAction, (state, { pagination }) => {
    return paginationAdapter.upsertOne(pagination, {
      ...state,
    });
  }),
  on(paginationActions.deleteAction, (state, { id }) => {
    return paginationAdapter.removeOne(id, {
      ...state,
    });
  }),
  on(paginationActions.clear, (state) => initialState)
);
